import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css'
import '../static/ub_icons/css/ub.css'
import '../static/fonts/style.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    primary: '#4A87FF',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FD6A3E',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  customProperties: true,
  iconfont: ['fa','mdi', 'ub'],
});
